import { ArrangementProduct } from "../types";

export const demoArrangementCatalog: ArrangementProduct[] = [
  {
    id: "classic-oak-tribute",
    category: "casket",
    name: "Classic Oak Tribute",
    description: "Warm oak finish with traditional detailing for a formal burial service.",
    priceLabel: "Estimated range · director will confirm pricing",
    imageTone: "oak",
    tags: ["Recommended", "Burial", "Traditional"],
    recommendedFor: ["burial", "entombment"],
  },
  {
    id: "brushed-silver-serenity",
    category: "casket",
    name: "Brushed Silver Serenity",
    description: "A polished silver-toned selection with a calm, contemporary presentation.",
    priceLabel: "Estimated range · director will confirm pricing",
    imageTone: "silver",
    tags: ["Contemporary", "Burial"],
    recommendedFor: ["burial", "entombment"],
  },
  {
    id: "white-rose-remembrance",
    category: "casket",
    name: "White Rose Remembrance",
    description: "Soft white finish with floral detail for a bright remembrance service.",
    priceLabel: "Estimated range · director will confirm pricing",
    imageTone: "white",
    tags: ["Light finish", "Formal"],
    recommendedFor: ["burial"],
  },
  {
    id: "simple-natural-pine",
    category: "casket",
    name: "Simple Natural Pine",
    description: "Simple natural wood presentation for families seeking a modest selection.",
    priceLabel: "Estimated range · director will confirm pricing",
    imageTone: "pine",
    tags: ["Simple", "Natural"],
    recommendedFor: ["burial"],
  },
  {
    id: "marble-keepsake-urn",
    category: "urn",
    name: "Marble Keepsake Urn",
    description: "A polished keepsake urn with soft marble variation.",
    priceLabel: "Director will confirm pricing",
    imageTone: "marble",
    tags: ["Cremation", "Keepsake"],
    recommendedFor: ["cremation", "undecided"],
  },
  {
    id: "brushed-bronze-urn",
    category: "urn",
    name: "Brushed Bronze Urn",
    description: "Warm bronze finish with classic proportions.",
    priceLabel: "Director will confirm pricing",
    imageTone: "bronze",
    tags: ["Cremation", "Classic"],
    recommendedFor: ["cremation"],
  },
  {
    id: "monarch-gold-folder",
    category: "service_folder",
    name: "Monarch Gold Embossed Folder",
    description: "Printed or digital service folder with Monarch gold detailing and QR access.",
    priceLabel: "Draft included · print pricing confirmed by director",
    imageTone: "gold",
    tags: ["Recommended", "QR-ready", "Print later"],
    recommendedFor: ["burial", "cremation", "entombment", "undecided"],
  },
  {
    id: "photo-tribute-program",
    category: "service_folder",
    name: "Photo Tribute Program",
    description: "Photo-forward program layout for readings, music, acknowledgments, and story.",
    priceLabel: "Draft included · director will confirm printing",
    imageTone: "ivory",
    tags: ["Photo tribute", "Digital"],
    recommendedFor: ["burial", "cremation", "undecided"],
  },
  {
    id: "embossed-folder-bundle",
    category: "keepsake",
    name: "Embossed Service Folder Bundle",
    description: "Keepsake copies of the service folder for close family members.",
    priceLabel: "Request this keepsake",
    imageTone: "gold",
    tags: ["Family request", "No checkout"],
  },
  {
    id: "memorial-tree-gift",
    category: "keepsake",
    name: "Memorial Tree Gift",
    description: "A sympathy gift guests or family can request from the memorial hub.",
    priceLabel: "Request this keepsake",
    imageTone: "green",
    tags: ["Guest option", "CRM follow-up"],
  },
  {
    id: "guestbook-memory-print",
    category: "keepsake",
    name: "Guestbook Memory Print",
    description: "A printed keepsake of guest messages and shared memories.",
    priceLabel: "Request this keepsake",
    imageTone: "ivory",
    tags: ["Guestbook", "Aftercare"],
  },
];

export function getProduct(productId: string) {
  return demoArrangementCatalog.find((product) => product.id === productId);
}

export function getProductsByCategory(category: ArrangementProduct["category"]) {
  return demoArrangementCatalog.filter((product) => product.category === category);
}
